/*
 * WaWiAuftragBelege.tsx
 *
 * Created by Dr. Maximillian Dornseif in huWaWi3
 * Copyright (c) 2023 HUDORA GmbH
 */

import { LadeChecker } from '@hudora/hd-react-components'
import * as R from 'ramda'
import React from 'react'
import { useQuery } from 'urql'

import { LinkRender } from '../../lib/hd-link'
import { HdCard } from '../components/HdCard'
import { AUFTRAGBELEGE_QUERY } from './WaWiAuftragAppQueries'

export function Belege({ auftrag, nr }) {
  const [{ fetching: loading, error, data }] = useQuery({ query: AUFTRAGBELEGE_QUERY, variables: { nr } })

  const belege = R.sortWith(
    [R.ascend(R.prop('belegdatum') as any), R.ascend(R.prop('created_at') as any)],
    data?.entity?.belege || []
  )

  return (
    <HdCard title="Belege">
      <LadeChecker loading={loading} error={error} label={`Lade Belege`}>
        {belege?.length < 1 ? (
          <div>noch keine Belege</div>
        ) : (
          <ul>
            {belege?.map((x: Record<string, any>) => (
              <li key={x.designator}>
                <LinkRender value={x.designator} />
                {': '}
                {x.name}
              </li>
            ))}
          </ul>
        )}
      </LadeChecker>
    </HdCard>
  )
}
